import { useState, useEffect, useRef } from 'react';
import Wingraphs from "./wingraphs.js"
import invoke from "../calllambda"
import Weathergraphpanel from "./weathergraphpanel.js"
import styles from './css/pastdata.module.css'

export default function Pastdata(props) {
    const [win, setWin] = useState([]);
    const [datetime, setDatetime] = useState("");
    const [way, setWay] = useState("");
    const [weather, setWeather] = useState([]);
    const [beforedate, setBeforedate] = useState("");
    const [names, setNames] = useState([]);
    const winref = useRef();
    const weatherref = useRef();

    useEffect(() => {
        if (props.point && props.point.sensors && props.point.sensors.earthquake && props.point.sensors.earthquake.length > 0 && datetime !== "") {
            invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:downloadwin", { sensor_id: props.point.sensors.earthquake[0].id, datetime: datetime, way: way }).then(function (value) {
                if (value !== undefined && value !== "") {
                    var windata = Uint8Array.from(atob(value.win), s => s.charCodeAt(0));
                    if (windata !== "") {
                        setWin(windata);
                        var elm = document.getElementById("datetime");
                        elm.value = value.datetime;
                    }
                    setNames(props.point.sensors.earthquake[0].name)
                }
            });
        } else {
            setWin([]);
        }
    }, [props.point, datetime, way]);

    useEffect(() => {
        if (props.point && props.point.sensors && props.point.sensors.earthquake && props.point.sensors.weather.length > 0 && datetime !== "") {
            var ymd = datetime.substring(0,10)
            if ( ymd !== beforedate ) {
                invoke("arn:aws:lambda:ap-northeast-1:068557983663:function:sensordata", { sensor_id: props.point.sensors.weather[0].id, datetime: ymd }).then(function (value) {
                    setWeather(value);
                    setBeforedate(ymd);
                });
            }
        } else {
            setWeather({});
        }
    }, [props.point, datetime]);

    function changeDatetime(diffmin = 0) {
        var elm = document.getElementById("datetime");
        var datetime = elm.value;
        if (datetime !== "" && diffmin !== 0) {
            var dt = new Date(datetime);
            dt.setMinutes(dt.getMinutes() + diffmin);
            dt.setHours(dt.getHours() + 9);//日本時間対応(イマイチ)
            datetime = dt.toISOString();
        }
        setWay(diffmin);
        setDatetime(datetime);
    }

    return (
        <>
            <div style={{ display: "flex", padding: "0 0.5em 0.5em" }}>
                <span style={{ verticalAlign: "middle" }}><input type="datetime-local" id="datetime"></input></span>
                <span style={{ textAlign: "center" }}><button style={{}} type="button" onClick={() => { changeDatetime(); }}>表示</button></span>
                <span style={{ textAlign: "center" }}><button style={{}} type="button" onClick={() => { changeDatetime(-1); }}>◀</button></span>
                <span style={{ textAlign: "center" }}><button style={{}} type="button" onClick={() => { changeDatetime(1); }}>▶</button></span>
            </div>
            <div className={styles.header}>
                <div className={styles.title}>気象データ</div>
                <div className={styles.discription}><a href="#" onClick={() => weatherref.current?.download()}>Download</a></div>
            </div>
            <div>
                {weather.datetime ? (<Weathergraphpanel data={weather} ref={weatherref}/>) : "データがありません"}
            </div>
            <div className={styles.header}>
                <div className={styles.title}>振動波形</div>
                <div className={styles.discription}><a href="#" onClick={() => winref.current?.download()}>Download</a></div>
            </div>
            <div>
                {win.length > 0 ? (<Wingraphs height={200} win={win} names={names} ref={winref}/>) : "データがありません"}
            </div>
        </>
    );

}